import { createStore } from 'vuex'
import { defaultLang } from '@/config/lang'

export default createStore({
  state: {
    locale: defaultLang,
    cpUserInfo: {}
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale
    },
    SET_CP_USER_INFO(state, cpUserInfo) {
      state.cpUserInfo = cpUserInfo
    }
  },
  actions: {
  },
  modules: {
  }
})
